<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('string.editLoan') }}
      </h3>
      <div class="box-tools">
        <asora-back-button />
      </div>
    </div>
    <div class="box-body">
      <p>{{ $t('string.notAllowToEditLoan') }}</p>
    </div>
  </div>
</template>

<script>
import AsoraBackButton from '../../components/AsoraBackButton'

export default {
  name: 'Edit',
  components: { AsoraBackButton }
}
</script>

<style scoped>

</style>
